<div class="implementation-code code-wrapper" [ngClass]="{ 'one-line': asOneLine }">
  <div (click)="copyInputMessage(code ?? '')" class="copy-button">
    <nb-icon class="copy-icon" icon="copy" pack="icomoon"></nb-icon>
  </div>
  <code>{{code}}</code>
</div>
